const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/case-card',
  component: Module,
  children: [
    {
      path: ':id',
      name: 'case-card-home',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
